/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import { Link } from 'gatsby';
import { useInView } from 'react-intersection-observer';
import { IoIosArrowRoundForward } from 'react-icons/io';
import Img from 'gatsby-image';
import WrongImagePlaceholder from '../../WrongImagePlaceholder';
import ResultTechIcon from './ResultTechIcon';

const ResultItem = ({ caseStudy: item, className, disableLinkOnSwipe }) => {
  const [startX, setStartX] = useState(0);
  const [endX, setEndX] = useState(0);
  const [ref, inView] = useInView({
    /* Optional options */
    triggerOnce: true,
    rootMargin: '400px 0px'
  });

  const handleOnClick = e => {
    if (!disableLinkOnSwipe) return;
    if (Math.abs(startX - endX) > 10) {
      // prevent navigation to case study if there was a swipe instead of click
      e.preventDefault();
    }
  };

  const handleMouseDown = e => {
    if (!disableLinkOnSwipe) return;
    setStartX(e.clientX);
  };

  const handleMouseUp = e => {
    if (!disableLinkOnSwipe) return;
    setEndX(e.clientX);
  };

  return (
    <div className={`${className} results-link`}>
      <div className="swiper-slide">
        <div className="left-pistil">
          <div className="content">
            <div className="upper">
              <div className="nn">{item.frontmatter.info.industry}</div>
              <h2 className="tt">
                <Link
                  onClick={handleOnClick}
                  onMouseDown={handleMouseDown}
                  onMouseUp={handleMouseUp}
                  ref={ref}
                  to={item.fields.slug}
                >
                  <span>{item.frontmatter.title}</span>
                </Link>
              </h2>
              <div
                className="dd"
                dangerouslySetInnerHTML={{
                  __html: item.frontmatter.header
                }}
              />
            </div>
            <div className="bottom">
              {!!item.frontmatter.technologies.icons && (
                <div className="logotypes">
                  {inView ? (
                    item.frontmatter.technologies.icons.map(icon => (
                      <ResultTechIcon icon={icon} key={icon} />
                    ))
                  ) : (
                    <div style={{ minHeight: '38px' }} />
                  )}
                </div>
              )}
              <Link to={item.fields.slug} className="read-more">
                Read more <IoIosArrowRoundForward />
              </Link>
            </div>
          </div>
        </div>
        <Link
          to={item.fields.slug}
          className="right-pistil"
          style={{ background: 'none' }}
        >
          {item.frontmatter.images.card ? (
            <Img
              draggable={false}
              fluid={item.frontmatter.images.card.childImageSharp.fluid}
              className="gatsby-image-fit-height result-item-img"
              alt={item.frontmatter.info.industry}
              title={item.frontmatter.title}
            />
          ) : (
            <WrongImagePlaceholder />
          )}
        </Link>
      </div>
    </div>
  );
};

export default ResultItem;

ResultItem.defaultProps = {
  className: 'result-item',
  disableLinkOnSwipe: false
};
